import { useEffect } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import { loadTossPayments } from "@tosspayments/tosspayments-sdk";
import styled from "styled-components";
import Lottie from 'lottie-react-web';

import FetchModule from "../../../Model/Network/FetchModule";

// Animation //
import LoadingAnimation from '../../../Animation/LoadingAnimation.json';
// Animation //

// 고객키별 카드 등록 시도 횟수 저장 키 //
const ATTEMPT_KEY_PREFIX = 'CardRegistrationAttempt-';

// 동일 고객키 기준 카드 등록 시도 횟수 증가 //
function increaseAttemptCount(customerKey) {
  let key = ATTEMPT_KEY_PREFIX + customerKey;
  let count = parseInt(window.localStorage.getItem(key) || '0', 10) + 1;

  window.localStorage.setItem(key, count.toString());

  return count;
}

// 카드 등록 실패 사유 서버 기록 (실패 화면 전환 중 유실 방지를 위해 keepalive 사용) //
function sendRegistrationFailure(baseUrl, failureData) {
  try {
    fetch(baseUrl + '/api2/card/registration/failure', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(failureData),
      keepalive: true
    }).catch(() => {
      // 실패 기록 전송 오류는 무시 //
    });
  }
  catch (e) {
    // 실패 기록 전송 오류는 무시 //
  }
}

export default function CardRegistrationRequestPage() {
  const navigate = useNavigate();
  const params = useParams();
  

  // 토스 클라이언트 키 — Zone 프론트와 동일 상점 키, .env(REACT_APP_TOSS_CLIENT_KEY) 배선 //
  const TosspaymentsKey = process.env.REACT_APP_TOSS_CLIENT_KEY;
  const url = 'https://coach.link-zone.org';
  // const url = 'http://192.168.0.101:7070';

  // 카드 등록을 위한 토클 발행 후 카드 등록 실행 //
  useEffect(() => {
    window.localStorage.setItem('Token', 'Bearer ' + params.token);
    
    let merchantUid = params.merchantUid;
    let itemName = params.itemName;

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.getDataOfCoachVer2('card/auth_publication', 'GET');
        
        if (responseData.status === 200) {
          let token = responseData.data.token;
          let userId = responseData.data.userId;
          let customerKey = responseData.data.customerKey;

          const tosspayments = await loadTossPayments(TosspaymentsKey);

          const brandPay = tosspayments.brandpay({
            customerKey: customerKey,
            redirectUrl: url + '/api2/card/registration/auth'
          })

          let startedAt = Date.now();
          let attemptNo = increaseAttemptCount(customerKey);

          brandPay.addPaymentMethod()
            .then(function () {
              window.localStorage.removeItem(ATTEMPT_KEY_PREFIX + customerKey);

              let requestData = {
                itemName: itemName,
                merchantUid: merchantUid,
                userId: userId,
                customerKey: customerKey,
                token: token
              }
              
              const fetchModule = new FetchModule();
              (
                async () => {
                  const responseData = await fetchModule.postDataOfEventVer2('sales/registration/success', 'POST', requestData);

                  if (responseData.status === 200) {
                    let encodedeMessage = encodeURIComponent('결제가 완료되었습니다');

                    navigate('/payment/complete/200/' + encodedeMessage);
                  }
                  else {
                    let encodedeMessage = encodeURIComponent(responseData.error);

                    navigate('/payment/complete/400/' + encodedeMessage);
                  }
                }
              )();
            })
            .catch((e) => {
              sendRegistrationFailure(url, {
                customerKey: customerKey,
                userId: userId,
                errorCode: e && e.code ? e.code : 'UNKNOWN',
                errorMessage: e && e.message ? e.message : '',
                errorName: e && e.name ? e.name : '',
                elapsedMs: Date.now() - startedAt,
                attemptNo: attemptNo,
                path: 'event',
                merchantUid: merchantUid,
                itemName: itemName,
                userAgent: window.navigator.userAgent
              });

              let encodedeMessage = encodeURIComponent('카드 등록에 실패하였습니다');

              navigate('/payment/complete/400/' + encodedeMessage);
            })
        }
        else {
          let encodedeMessage = encodeURIComponent('카드등록 절차가 실패하였습니다');
          
          navigate('/payment/complete/400/' + encodedeMessage);
        }
      }
    )();
  }, [TosspaymentsKey]);

  return (
    <TopLevelWrapper id='payment-method'>
      <LottieWrapper>
        <LottieBox>
          <Lottie options={{ animationData: LoadingAnimation }} />
        </LottieBox>
        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#000000'>결제 모듈 로딩중...</Text>
      </LottieWrapper>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100vw;
  height: 100vh;

  background-color: #FFFFFF;
`;

const LottieWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  gap: 8px;
`;

const LottieBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 60px;
  height: 60px;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize};

  color: ${props => props.color};

  margin: 0 0 0 0;
`;